import React from "react";
import { Skeleton } from "../PainelShimmerChrome";
import "./SolutionsTableSkeleton.scss";

const ROW_COUNT = 8;

interface SolutionsTableSkeletonProps {
  isDarkMode?: boolean;
}

const SolutionsTableSkeleton: React.FC<SolutionsTableSkeletonProps> = ({
  isDarkMode = false,
}) => (
  <div
    className={`solutions-table-skeleton__wrap${isDarkMode ? " solutions-table-skeleton__wrap--dark" : ""}`}
    aria-busy="true"
    aria-label="Carregando soluções"
  >
    <table className="solutions-table-skeleton__table">
      <thead>
        <tr>
          <th>Estabelecimento</th>
          <th>Título</th>
          <th>Solução</th>
          <th>Ícone</th>
          <th>HREF</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: ROW_COUNT }, (_, index) => (
          <tr key={index} className="solutions-table-skeleton__row">
            <td><Skeleton height={14} width="58%" /></td>
            <td><Skeleton height={14} width="82%" /></td>
            <td><Skeleton height={14} width="74%" /></td>
            <td><Skeleton height={14} width="70%" /></td>
            <td><Skeleton height={14} width="88%" /></td>
            <td>
              <div className="solutions-table-skeleton__actions">
                <Skeleton height={32} width={32} borderRadius="50%" />
                <Skeleton height={32} width={32} borderRadius="50%" />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SolutionsTableSkeleton;
